/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
// import { useEffect,useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import MainPage from './pages/MainPage';
import MyTimocom from "./pages/my-timocom/My-Timocom";
import LoginPage from "./pages/loginPage/loginPage";
import './App.css';

function App() {
  
  return (
    <div className="App">
       <Router>
          <Routes>
            <Route path="/iam.timocom.com/*" element={<LoginPage/>} />
            <Route path="/realms/*" element={<LoginPage/>} />
            <Route path="/my.timocom.com/app/tcgate" element={<MyTimocom/>} />
            <Route path="*" element={<MainPage />} />
          </Routes> 
      </Router>
    </div>
  );
}

export default App;
